const Actions = Object.freeze({

  // User
  USER_SET_USER: 'USER_SET_USER',
  USER_SET_FRIENDS: 'USER_SET_FRIENDS',
  USER_SET_GAMES: 'USER_SET_GAMES',
  USER_APPEND_GAME: 'USER_APPEND_GAME',
  USER_SET_IS_LOGGING_IN: 'USER_SET_IS_LOGGING_IN',
  USER_SET_LOGIN_RESPONSE: 'USER_SET_LOGIN_RESPONSE',
  USER_CLEAR: 'USER_CLEAR',

  // System
  SYSTEM_SET_IS_INIT: 'SYSTEM_SET_IS_INIT',
  SYSTEM_SET_SERVER_TIME_OFFSET: 'SYSTEM_SET_SERVER_TIME_OFFSET',
  SYSTEM_SET_CONSTANTS: 'SYSTEM_SET_CONSTANTS',
  SYSTEM_SET_GAME_TYPES: 'SYSTEM_SET_GAME_TYPES',
  SYSTEM_SET_SYSTEM_MESSAGE: 'SYSTEM_SET_SYSTEM_MESSAGE',
  SYSTEM_DELETE_SYSTEM_MESSAGE: 'SYSTEM_DELETE_SYSTEM_MESSAGE',

  // UI
  UI_SET_ACTIVE_PAGE: 'UI_SET_ACTIVE_PAGE',
  UI_SET_NEW_GAME_TAB: 'UI_SET_NEW_GAME_TAB',
  UI_SET_INVITE_TAB: 'UI_SET_INVITE_TAB',
  UI_SET_ACTIVE_TAB: 'UI_SET_ACTIVE_TAB',
  UI_SET_PAST_TAB: 'UI_SET_PAST_TAB',

  // GAME
  GAME_SET_GAME: 'GAME_SET_GAME',
  GAME_SET_IS_SUBMITTING: 'GAME_SET_IS_SUBMITTING',
  GAME_UPDATE: 'GAME_UPDATE',
  GAME_SET_FINAL: 'GAME_SET_FINAL',
  GAME_ADD_SUBMITTED_PLAYER: 'GAME_ADD_SUBMITTED_PLAYER',

  SOCKET: 'SOCKET'

  // Broadcast
  //BROADCAST_ACTION: 'BROADCAST_ACTION'
})

export default Actions
  